import React, { Component } from "react";
import PropTypes from "prop-types";

// STATE AND STORE
// LIBS
import { sumFormat } from "../../../lib/helpers/strings";
import { getFilialSumsHistorys } from "../../../lib/helpers/history";

// UI
import { Row, Col, Header, P, Label, Section, VirtualDiv } from "../../../ui";

export default class DaySumAllFilialTable extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    saved: PropTypes.bool.isRequired,
    filial: PropTypes.objectOf(
      PropTypes.shape({
        filial_id: PropTypes.shape({
          _id: PropTypes.string.isRequired
        }).isRequired,
        cash_desk_start_day: PropTypes.number.isRequired,
        sum_add: PropTypes.number.isRequired,
        sum_remove: PropTypes.number.isRequired,
        sum_remove_to_sale: PropTypes.number.isRequired,
        cash_desk: PropTypes.number.isRequired,
        historys: PropTypes.arrayOf(PropTypes.object)
      })
    ),
    user: PropTypes.objectOf(
      PropTypes.shape({
        _id: PropTypes.string.isRequired,
        fio: PropTypes.string.isRequired
      })
    )
  };

  render() {
    const { loading, saved, filial } = this.props;

    if (loading) {
      return null;
    }

    let filialSums = getFilialSumsHistorys(filial.historys);

    // let filialSumsCorrect = {
    //   sum_give: filialSums.sum_give === filial.sum_give,
    //   sum_percent: filialSums.sum_percent === filial.sum_percent,
    //   sum_fine: filialSums.sum_fine === filial.sum_fine,
    //   sum_income_with_return:
    //     filialSums.sum_income_with_return === filial.sum_income_with_return
    // };

    let cashDeskCalc = 0;

    if (saved) {
      cashDeskCalc =
        parseInt(filial.cash_desk_start_day, 10) -
        parseInt(filialSums.sum_give, 10) +
        parseInt(filialSums.sum_percent, 10) +
        parseInt(filialSums.sum_fine, 10) +
        parseInt(filial.sum_return, 10) +
        parseInt(filial.sum_add, 10) -
        parseInt(filial.sum_remove, 10);
      // Списание не считается, так как идёт две операции:
      // Выкуп на выданную сумму и изъятие на выданную сумму (+ затем -)
      // parseInt(filial.sum_remove_to_sale, 10);
    }

    let isCorrect = saved && parseInt(filial.cash_desk, 10) === cashDeskCalc;

    // TODO: Прогнать все historys и посчитать все суммы для сравнения с filial.sum...

    return (
      <div className="sums-filial">
        <Section
          theme={saved && !isCorrect ? "error" : "white"}
          className="sums-filial__line"
        >
          <div className="item cashDeskStart">
            <P slim={true} size="x-small">
              Начало дня
            </P>
            <Header margin="no" size={6}>
              {sumFormat(filial.cash_desk_start_day)}
            </Header>
          </div>

          <div className="item sumAdd">
            <Row align="center">
              <Col padding="no">
                <Label slim={true} size="x-small">
                  Пополнение
                </Label>
                <P slim={true} strong={true} size="small">
                  {sumFormat(filial.sum_add)}
                </P>
              </Col>
            </Row>
          </div>

          <div className="item sumRemove">
            <Row align="center">
              <Col padding="no">
                <Label slim={true} size="x-small">
                  Расход
                </Label>
                <P slim={true} strong={true} size="small">
                  {sumFormat(filial.sum_remove)}
                </P>
              </Col>
            </Row>
          </div>

          <div className="item sumClose">
            <Row align="center">
              <Col padding="no">
                <Label slim={true} size="x-small">
                  Списание
                </Label>
                <P slim={true} strong={true} size="small">
                  {sumFormat(filial.sum_remove_to_sale)}
                </P>
              </Col>
            </Row>
          </div>

          <div className="item cashDesk">
            <P slim={true} size="x-small">
              {saved ? "Конец дня" : "Сейчас"}
            </P>
            <Header
              margin="no"
              size={6}
              className={saved && !isCorrect ? "color-error" : ""}
            >
              {sumFormat(filial.cash_desk)}
            </Header>

            {saved && !isCorrect ? (
              <VirtualDiv>
                <br />
                <P slim={true} size="x-small">
                  Должно быть
                </P>
                <Header margin="no" size={6}>
                  {sumFormat(cashDeskCalc)}
                </Header>
              </VirtualDiv>
            ) : null}
          </div>
        </Section>
      </div>
    );
  }
}
